var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundPusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 13.1665C4.37621 13.1665 1.83329 10.6236 1.83329 7.49984C1.83329 4.37609 4.37621 1.83317 7.49996 1.83317C10.6237 1.83317 13.1666 4.37609 13.1666 7.49984C13.1666 10.6236 10.6237 13.1665 7.49996 13.1665ZM7.49996 0.416504C6.56976 0.416504 5.64867 0.59972 4.78928 0.955691C3.9299 1.31166 3.14903 1.83342 2.49129 2.49116C1.1629 3.81955 0.416626 5.62122 0.416626 7.49984C0.416626 9.37845 1.1629 11.1801 2.49129 12.5085C3.14903 13.1663 3.9299 13.688 4.78928 14.044C5.64867 14.4 6.56976 14.5832 7.49996 14.5832C9.37858 14.5832 11.1802 13.8369 12.5086 12.5085C13.837 11.1801 14.5833 9.37845 14.5833 7.49984C14.5833 6.56964 14.4001 5.64855 14.0441 4.78916C13.6881 3.92977 13.1664 3.14891 12.5086 2.49116C11.8509 1.83342 11.07 1.31166 10.2106 0.955691C9.35124 0.59972 8.43016 0.416504 7.49996 0.416504ZM8.20829 3.95817H6.79163V6.7915H3.95829V8.20817H6.79163V11.0415H8.20829V8.20817H11.0416V6.7915H8.20829V3.95817Z",
    fill: "#7CBE7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPusIcon);
export default __webpack_public_path__ + "static/media/round-pus-icon.5517d64f5aa3c92d800fa91820fc65c6.svg";
export { ForwardRef as ReactComponent };